export const mapQueryKeys = {
  all: ['map'] as const,

  publicEvents: (active: boolean) => [...mapQueryKeys.all, 'publicEvents', { active }] as const,

  toiletFacilities: (
    bounds: { ne: { lat: number; lng: number }; sw: { lat: number; lng: number } },
    zoom: number
  ) => {
    // Normalize bounds to grid cells for better cache reuse
    const gridSize = 0.01 // ~1km grid cells
    const normalizedBounds = {
      ne: {
        lat: Math.ceil(bounds.ne.lat / gridSize) * gridSize,
        lng: Math.ceil(bounds.ne.lng / gridSize) * gridSize,
      },
      sw: {
        lat: Math.floor(bounds.sw.lat / gridSize) * gridSize,
        lng: Math.floor(bounds.sw.lng / gridSize) * gridSize,
      },
    }
    const zoomLevel = Math.floor(zoom) // Normalize zoom to integer levels
    return [
      ...mapQueryKeys.all,
      'toiletFacilities',
      { bounds: normalizedBounds, zoomLevel },
    ] as const
  },

  customMarkers: () => [...mapQueryKeys.all, 'customMarkers'] as const,

  pastUserEvents: () => [...mapQueryKeys.all, 'pastUserEvents'] as const,

  connections: () => [...mapQueryKeys.all, 'connections'] as const,

  postcodeCoordinates: (postcode: string) => [...mapQueryKeys.all, 'postcode', postcode] as const,

  recommendedEvents: () => [...mapQueryKeys.all, 'recommendedEvents'] as const,

  reverseGeocode: (lat: number, lng: number) =>
    [...mapQueryKeys.all, 'reverseGeocode', { lat, lng }] as const,
} as const

export const calendarQueryKeys = {
  all: ['calendar'] as const,

  invitedEvents: () => [...calendarQueryKeys.all, 'invitedEvents'] as const,

  publicEvents: (active: boolean) =>
    [...calendarQueryKeys.all, 'publicEvents', { active }] as const,

  eventsByUser: (userId?: string) =>
    [...calendarQueryKeys.all, 'eventsByUser', { userId }] as const,

  eventById: (eventId: string) => [...calendarQueryKeys.all, 'event', eventId] as const,

  publicEventById: (eventId: string) => [...calendarQueryKeys.all, 'publicEvent', eventId] as const,

  publicEventParticipants: (eventId: string) =>
    [...calendarQueryKeys.all, 'publicEventParticipants', eventId] as const,

  // Combined calendar data for specific date ranges
  calendarData: (startDate?: Date, endDate?: Date) =>
    [
      ...calendarQueryKeys.all,
      'calendarData',
      { startDate: startDate?.toISOString(), endDate: endDate?.toISOString() },
    ] as const,
} as const

export const chatQueryKeys = {
  all: ['chat'] as const,

  // Media URLs for chat images
  // Sort media IDs to ensure consistent cache keys regardless of order
  mediaUrls: (mediaIds: string[]) =>
    [...chatQueryKeys.all, 'mediaUrls', [...mediaIds].sort()] as const,

  // Connection details by conversation SID
  connectionBySid: (conversationSid: string) =>
    [...chatQueryKeys.all, 'connection', conversationSid] as const,

  // All connections list
  connections: () => [...chatQueryKeys.all, 'connections'] as const,

  // Pending requests (connections + events)
  pendingRequests: () => [...chatQueryKeys.all, 'pendingRequests'] as const,

  // Connection stats (counts only)
  connectionStats: () => [...chatQueryKeys.all, 'connectionStats'] as const,
} as const
